export default "__VITE_ASSET__wJa86gsm__"